import React                   from 'react';
import { Group, Paper, Title } from '@mantine/core';
import { IconMap2 }            from '@tabler/icons';
import useStyles               from './DetailsTitle.styles';


interface Props {
    name: string;
    address: string;
}

export const DetailsTitle: React.FC<Props> = ({
                                                  name,
                                                  address
                                              }) => {

    const { classes } = useStyles();


    return (
        <Paper>
            <Title lineClamp={1} className={classes.h1} order={1}>{name}</Title>
            <Group className={classes.titleLocation}>
                <IconMap2 className={classes.locationIcon} stroke={1}/>
                <Title lineClamp={1} className={classes.h2} order={2}>{address}</Title>
            </Group>
        </Paper>
    )

}
